import React, { Component } from "react";
import { connect } from "react-redux";
import {
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage
} from "actions/image";
import {
  fetchAvailableGateway,
  updateAvailableGateway
} from "actions/availableGateway";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/AvailableGateway/Form";

class AvailableGatewayEdit extends Component {
  componentDidMount() {
    const { match, fetchAvailableGateway } = this.props;
    const id = match.params.gatwayId;

    fetchAvailableGateway(id);
  }

  updateAvailableGateway(id, data) {
    const {
      toggleNotification,
      toggleFullPageSpinner,
      updateAvailableGateway,
      history
    } = this.props;

    toggleFullPageSpinner(true);

    updateAvailableGateway(id, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated Payment Gateway Success",
          infoClassName: "is-success"
        });
        history.push(`/available-gateways`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.gatwayId;
    this.updateAvailableGateway(id, data);
  };

  render() {
    const {
      uploadImage,
      availableGateway,
      removeUploadedImage,
      uploadedImages,
      uploadedImagesPreview,
      uploadedImagesPercentage,
      setUploadedImagePreview
    } = this.props;

    if (availableGateway.loading) {
      return "loading";
    }
    return (
      <Form
        uploadImage={uploadImage}
        uploadedImages={uploadedImages}
        setUploadedImagePreview={setUploadedImagePreview}
        removeUploadedImage={removeUploadedImage}
        uploadedImagesPreview={uploadedImagesPreview}
        uploadedImagesPercentage={uploadedImagesPercentage}
        handleFormSubmit={this.handleFormSubmit}
        defaultValues={this.props.availableGateway.data}
      />
    );
  }
}

const mapStateToProps = ({
  availableGateway,
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview
}) => ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  availableGateway
});

export default connect(mapStateToProps, {
  fetchAvailableGateway,
  updateAvailableGateway,
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage,
  setUploadedImagePreview,
  toggleFullPageSpinner,
  toggleNotification
})(AvailableGatewayEdit);



// WEBPACK FOOTER //
// ./src/pages/AvailableGateway/Edit/index.js